export default "__VITE_ASSET__CyHQmPbT__"